import type { AdInterface } from "types/ad";
import { SubCategory } from "types/subCategory";

/** Category-specific payload shared by public ad and service detail views. */
export type CategoryDetailData = AdInterface["data"];

export type ListingDetailKind = "ad" | "service";

export interface ListingCategoryDetail {
    subcategory: SubCategory;
    data: CategoryDetailData;
}

export interface ListingDetailLabelKeys {
    bringYes: string;
    bringNo: string;
    equipment: string | null;
    deviceType: string;
    academicLevel: string;
}

export function getListingDetailLabelKeys(kind: ListingDetailKind): ListingDetailLabelKeys {
    if (kind === "ad") {
        return {
            bringYes: "ad.label.bring_yes",
            bringNo: "ad.label.bring_no",
            equipment: null,
            deviceType: "our_services.label.device_type",
            academicLevel: "our_services.label.academic_level",
        };
    }

    return {
        bringYes: "our_services.label.bring_yes",
        bringNo: "our_services.label.bring_no",
        equipment: "our_services.label.equipment",
        deviceType: "our_services.label.device_type",
        academicLevel: "our_services.label.academic_level",
    };
}
